<template>
  <div>
    <navigation-drawer :titles="'داشبورد'"/>
    <router-view/>
  </div>
</template>

<script>
import NavigationDrawer from "@/Admin/components/navigationDrawer";
export default {
  name: "DashboardPage",
  components: {NavigationDrawer}
}
</script>

<style scoped>

</style>